<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CARD_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldCardName"
              v-model="queryData.cardName"
              maxlength="100"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CARD_TYPE')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectCardTypeCode"
              v-model="queryData.cardTypeCode"
              codeId="COD_CARD_TYPE"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <ur-data-grid
        ref="gridCard"
        :headers="columnCard"
        :data-source="dsCard"
        :options="options"
        @grid:row-click="onSelectRow"
      >
        <template #left-info>
          <ur-dropdown
            class="ur-data-grid__info__per-page"
            :items="perPageItems"
            v-model="rowsPerPage"
            @input="onChangePageSize"
          />
        </template>
        <template #right-info>
          <sui-button
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDownload"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>          
        </template>
      </ur-data-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedGridRowData="selectedGridRowData"
          @onClickSearch="onClickSearch"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import {urDataSet} from 'uidev-component/index.js';
import tab01 from './components/PGE_CMX_00008_T01.vue';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;


export default {
  name: 'PGE_CMX_00008', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    urDataGrid,
  }, 
  extends: BasePage,
  data() {
    return {
      dsCard: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
        height: DEFAULT_ROWS_PER_PAGE * DEFAULT_ROW_HEIGHT,
      },
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: 'Detail',
          component: tab01,
        },

      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        cardName: '',
        cardTypeCode: '',
      },
    };
  },
  computed: {
  },
  watch: {},
  created() {
    this.perPageItems = [
      { value: 5, text: '5 per page' },
      { value: 10, text: '10 per page' },
      { value: 15, text: '15 per page' },
    ];
    this.columnCard = [
      {
        value: 'cardName',
        text: this.$t('MSG_TXT_CARD_NM'),
      },
      {
        value: 'cardTypeCodeName',
        text: this.$t('MSG_TXT_CARD_TYPE'),
      },
      {
        value: 'finalModificationUserId',
        text: this.$t('MSG_TXT_FNL_MDFC_USR_ID'),
        component: {
          props: ['row', 'value'],
          template:
            `<cmp-user-name-link
              :pageId="'PGE_CMX_00008'"
              :displayType="'1'"
              :displayLanguageId="row.finalModificationDisplayLangId"
              :userId="row.finalModificationUserId"
              :userName="row.finalModificationUserName"
              :userGlobalName="row.finalModificationUserGlobalName"
              :departmentName="row.finalModificationDepartmentName"
              :departmentEnglishName="row.finalModificationDepartmentEnglishName"
              :type="'link'"
            />`
        },
      },
      {
        value: 'finalModificationDTM',
        text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
        customValue: function(value, row) {
          return utils.dateformatToClient(value)
        },
      },
    ];    
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    onClickSearch() {
      const dataParams = {
        cardName: this.queryData.cardName,
        cardTypeCode: this.queryData.cardTypeCode,
      };
      http.requestTest('get', '/api/v1/o9/card', {
      // http.request(this.contextPageId, 'DTS_XXX_XXXXX', {
        query: dataParams,
      }).then(res => {
        this.dsCard.setData(res.data);
      });
    },
    onClickReset() {
      this.queryData.cardName = '';
      this.$refs.codeSelectCardTypeCode.reset();
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onClickExcelDownload() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columnCard;
      const objGridDataset = this.dsCard;
      const sToday = utils.now('YYYYMMDDHHmmss');
      //TODO: Change sExcelName prefix 'excel' to your proper objectName
      const sExcelName = `excel_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    onSelectRow(row) {
      if(row) {
        this.selectedGridRowData = row;
      }
    },
    onChangePageSize(v) {
      this.$refs.gridCard.mx_pager.rowsPerPage = v;
      this.options.height =  v * DEFAULT_ROW_HEIGHT;
      this.$nextTick(() => {
        this.$refs.gridCard.mx_buildViewData();
      });
    },
        
  },
};
</script>

<style scoped>
</style>
